import { render, staticRenderFns } from "./registered-cases-overview.vue?vue&type=template&id=964475b2&scoped=true&"
import script from "./registered-cases-overview.vue?vue&type=script&lang=ts&"
export * from "./registered-cases-overview.vue?vue&type=script&lang=ts&"
import style0 from "./registered-cases-overview.vue?vue&type=style&index=0&id=964475b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964475b2",
  null
  
)

export default component.exports